import { React, useMemo, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const parseCodes = (value) => value
    .split(/[\s,;]+/)
    .map((code) => code.trim())
    .filter(Boolean);

const NegativarTitulo = () => {
    const [codesInput, setCodesInput] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    const codes = useMemo(() => parseCodes(codesInput), [codesInput]);

    function handleAlerta(texto, alertaStatus) {
        setMessage(texto);
        setStatus(alertaStatus);
        setOpenAlerta(true);
    }

    async function submitNegativarTitulo(e) {
        e.preventDefault();

        if (!codes.length) {
            handleAlerta('Informe ao menos um código de lançamento.', 'error');
            return;
        }

        setIsSubmit(true);

        const body = JSON.stringify({ codes });

        try {
            const response = await fetchFlask('negativarTitulo', body);
            handleAlerta(response.message, response.status);

            if (response.status === 'success') {
                setCodesInput('');
            }
        } finally {
            setIsSubmit(false);
        }
    }

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Negativar Títulos
            </PageHeader>

            <form action='' method='POST' id='formNegativarTitulo' onSubmit={submitNegativarTitulo} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Negativação de títulos no Serasa</h2>
                        </Box>
                        <p>
                            Informe os códigos de lançamento que devem ser enviados para negativação. Separe por linha, vírgula, ponto e vírgula ou espaço.
                        </p>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <FormatListNumberedRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Códigos de lançamento</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <TextField
                                required
                                multiline
                                minRows={8}
                                label='Códigos de lançamento'
                                placeholder={'Ex.: 12345\n12346\n12347'}
                                value={codesInput}
                                onChange={(e) => setCodesInput(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='ui-impact'>
                        <ReportProblemRoundedIcon />
                        <Box>
                            <strong>Ação de cobrança externa</strong>
                            <span>Os títulos informados serão enviados ao backend para negativação no Serasa.</span>
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da negativação</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Total de títulos</span>
                            <strong className={!codes.length ? 'is-empty' : undefined}>{codes.length || 'Nenhum código informado'}</strong>
                        </Box>
                        <Box>
                            <span>Operação</span>
                            <strong>Negativar no Serasa</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <WarningAmberRoundedIcon />
                        <p>
                            Revise os códigos antes de confirmar. A solicitação será enviada como lista em codes para o endpoint negativarTitulo.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>
                                {codes.length
                                    ? '1/1 preenchido'
                                    : '0/1 preenchido'}
                            </strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} disabled={!codes.length} startIcon={<BlockRoundedIcon />}>
                        Negativar Títulos
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default NegativarTitulo;
